import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createBlock(_component_checkbox_field, {
    "model-value": $props.modelValue,
    class: "_mt-3",
    condensed: true,
    "display-name": $options.refundAndCancellationPolicyFieldName,
    "label-class": "_flex",
    name: $props.name,
    "onUpdate:modelValue": $options.onInput,
    "data-qa": "crowdfunding-terms-agreement"
  }, {
    default: _withCtx(() => [
      ($options.hasCustomTerms)
        ? (_openBlock(), _createBlock(_component_localize, {
            key: 0,
            resource: _ctx.Resources.Checkout.StoreCheckboxTermsAndConditionsAgreementMessage
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                "format-key": "0",
                href: $options.customTosUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "gfu-link gfu-link--accent",
                "data-qa": "payment-options-link:CustomTermsOfService"
              }, _toDisplayString(_ctx.Resources.Checkout.CheckoutTermsOfServiceLabel), 9 /* TEXT, PROPS */, _hoisted_1),
              _createElementVNode("a", {
                "format-key": "1",
                href: $options.storesTermsOfServiceUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "gfu-link gfu-link--accent",
                "data-qa": "payment-options-link:StoreTermsOfService"
              }, _toDisplayString(_ctx.Resources.Checkout.StoreCheckoutTermsOfServiceLabel), 9 /* TEXT, PROPS */, _hoisted_2)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"]))
        : (_openBlock(), _createBlock(_component_localize, {
            key: 1,
            resource: _ctx.Resources.Checkout.CheckboxTermsAndConditionsAgreementMessage
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                "format-key": "0",
                href: $options.backersTermsOfServiceUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "gfu-link gfu-link--accent",
                "data-qa": "terms-of-service"
              }, _toDisplayString(_ctx.Resources.Checkout.TermsAndConditionsForBackersLink), 9 /* TEXT, PROPS */, _hoisted_3),
              _createElementVNode("a", {
                "format-key": "1",
                href: $options.refundAndCancellationPolicyUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "gfu-link gfu-link--accent",
                "data-qa": "refund-cancellation-policy"
              }, _toDisplayString($options.refundAndCancellationPolicyName), 9 /* TEXT, PROPS */, _hoisted_4)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model-value", "display-name", "name", "onUpdate:modelValue"]))
}